export default __webpack_public_path__ + "static/media/Equipe2.9a756fa7.png";